import {PageRequest, PageResponse} from '..';


export class ModuleInfoPageResponse extends PageResponse {
  content: ModuleInfo[];
}

export class ModuleInfoPageRequest extends PageRequest {
  projectId?: string;
  event?: string;
}

export class ModuleInfo {
  moduleId: number;
  type: number;
  size: number;
  checksum: number;
  numberOfSections: number;
  pdbAge: number;
  pdbGuid: string;
  pdbPath: string;
  fileName: string;
  timestamp: string;
  masterId: string;
  moduleProductIds: ModuleProductId[];
  cumulativeCountBySize: number;

  comment: string;
  modifyDate: string;
  reviewer: string;
}

export class ModuleProductId {
  moduleId: number;
  productId: number;
  projectName: string;
}

export class UpdateModuleInfoRequest {
  constructor(public type: number, public comment: string) {
  }
}

